import { useQuery } from "@tanstack/react-query";

import { courseUnitsApi, type CourseUnit } from "@/lib/api/courseUnits";

/**
 * The plan's acknowledged revision with its current projections. The draft
 * owner advances the unit only on a newer plan revision, but an activity's
 * references and coursework links change without one (a coursework save, a
 * publication, Remove from activity). Those read from the shared units query,
 * which their writers invalidate; the plan itself stays the acknowledged one.
 */
export function useUnitProjection<T extends CourseUnit | null | undefined>(courseId: string, unit: T): T {
  const units = useQuery({ queryKey: ["course-units", courseId], queryFn: () => courseUnitsApi.list(courseId), enabled: Boolean(unit) });
  const current = unit ? units.data?.find(row => row.id === unit.id) : undefined;
  if (!unit || !current) return unit;
  return { ...unit, activity_references: current.activity_references ?? unit.activity_references, activity_coursework: current.activity_coursework ?? unit.activity_coursework };
}
